import { useEffect } from 'react';
import type { DectResponse } from 'src/apis/contract-management/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

type RequestOptions = {
  url: string;
};

export function useDect({ url }: HookConfig) {
  const dect = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<DectResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    dect.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return dect;
}

export type DectRequest = ReturnType<typeof useDect>;

export function useOptionalDect({ url }: { url?: string }) {
  const dect = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<DectResponse>({
        ...baseConfig,
        url,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        // workaround for https://prisma.atlassian.net/browse/TAG-8049
        if (isServerError(error, 403)) {
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  useEffect(() => {
    if (!url) return;
    dect.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  if (!url) return;
  return dect;
}

export type OptionalDectRequest = ReturnType<typeof useOptionalDect>;
